const ADVPL_LANGUAGE_ID = 'advpl';
let advplLanguageRegistered = false;

// Keywords extraídos do grammar do advpl-vscode (totvs/advpl-vscode)
const ADVPL_KEYWORDS = [
  // Conditional — keyword.control.conditional
  'if', 'else', 'elseif', 'iif', 'endif',
  // Loop — keyword.control.loop
  'for', 'to', 'step', 'next',
  'while', 'enddo',
  'exit', 'loop', 'break', 'continue', 'goto',
  // Switch — keyword.control.switch
  'do', 'case', 'otherwise', 'endcase',
  // Block delimiters — keyword.control.*
  'begin', 'end', 'sequence', 'transaction',
  // Error handling
  'try', 'catch', 'finally',
  // Flow
  'return',
  // Variable scope modifiers — storage.modifier
  'local', 'private', 'public', 'static', 'default',
  // Declarations — storage.type.*
  'function', 'procedure', 'method', 'class', 'data', 'wsdata',
  'endclass', 'constructor', 'destructor',
  'inherit', 'as', 'from', 'of',
  // Function modifiers — storage.modifier
  'html', 'main', 'project', 'pyme', 'template', 'user', 'web', 'webuser',
  // OOP — keyword.class
  'self', '_super', 'nil',
  // TLPP – Namespaces
  'namespace', 'using',
  // TLPP – Annotations
  'annotation',
  // TLPP – Web Services — storage.type.ws / storage.type.method
  'wsservice', 'wsclient', 'wsrestful', 'wsmethod',
  'wssend', 'wsreceive', 'wsstruct',
  'endwsservice', 'endwsclient', 'endwsrestful', 'endwsstruct',
  // SQL blocks — keyword.control.beginsql / endsql
  'beginsql', 'endsql', 'alias',
  // Content blocks — keyword.control.begincontent / endcontent
  'begincontent', 'endcontent', 'var',
];

// Tipos extraídos de tipagem / tipo-dado / wsdata do grammar
const ADVPL_TYPES = [
  'character', 'char', 'string',
  'numeric', 'integer', 'double', 'decimal', 'float',
  'logical', 'boolean',
  'date',
  'array', 'block', 'codeblock',
  'object', 'json',
  'variadic', 'variant',
];

// Funções built-in comuns (o grammar do advpl-vscode não enumera, trata qualquer word() como função)
const ADVPL_BUILTINS = [
  'alltrim', 'strtran', 'substra', 'substr',
  'upper', 'lower', 'len', 'empty', 'valtype',
  'dtoc', 'ctod', 'stod', 'time',
  'aadd', 'asize',
];

const ADVPL_MONARCH_TOKENS = {
  defaultToken: '',
  tokenPostfix: '.advpl',
  ignoreCase: true,
  keywords: ADVPL_KEYWORDS,
  typeKeywords: ADVPL_TYPES,
  builtinFunctions: ADVPL_BUILTINS,
  operators: [
    ':=', '==', '!=', '<>', '<=', '>=', '<', '>', '=',
    '+', '-', '*', '/', '%', '^',
    '::', ':',
    '--', '++',
    '+=', '-=', '*=', '/=', '%=',
    '$',
  ],
  symbols: /[=><!~?:&|+\-*/^%.$]+/,
  escapes: /\\(?:[abfnrtv\\"'0-7]|x[0-9a-fA-F]{1,2})/,
  tokenizer: {
    root: [
      // Comentários de linha: * no início (xBase legacy), && e //
      [/^\s*\*.*$/, 'comment'],
      [/&&.*$/, 'comment'],
      [/\/\/.*$/, 'comment'],
      // Comentário de bloco /* */  (sem aninhamento — igual ao grammar do advpl-vscode)
      [/\/\*/, 'comment', '@comment'],

      // Diretivas de compilador: #define, #include, #ifdef, #xcommand, #xtranslate …
      [/^\s*#\w+.*/, 'keyword'],

      // Constantes booleanas: .T. / .F.  →  constant.language.boolean
      [/\.(t|f)\./, 'constant'],
      // Operadores lógicos: .AND. / .OR. / .NOT.  →  constant.language.boolean.operator
      [/\.(and|or|not)\./, 'operator'],
      // Annotation TLPP: @NomeAnnotation
      [/@[a-z_]\w*/, 'keyword'],

      // Strings
      [/"/, { token: 'string.quote', bracket: '@open', next: '@stringDouble' }],
      [/'/, { token: 'string.quote', bracket: '@open', next: '@stringSingle' }],

      // Números
      [/\d+\.\d+([eE][\-+]?\d+)?/, 'number.float'],
      [/0[xX][0-9a-fA-F]+/, 'number.hex'],
      [/\d+/, 'number'],

      // Chamada de função / método: word(
      [/([a-z_]\w*)(\s*)(\()/, [
        {
          cases: {
            '@keywords': 'keyword',
            '@typeKeywords': 'type',
            '@builtinFunctions': 'predefined',
            '@default': 'function',
          },
        },
        '',
        'delimiter.parenthesis',
      ]],

      // Identificadores e palavras-chave
      [/[a-z_]\w*/, {
        cases: {
          '@keywords': 'keyword',
          '@typeKeywords': 'type',
          '@builtinFunctions': 'predefined',
          '@default': 'identifier',
        },
      }],

      [/[{}()[\]]/, '@brackets'],
      [/[;,.]/, 'delimiter'],
      [/@symbols/, {
        cases: {
          '@operators': 'operator',
          '@default': '',
        },
      }],
    ],

    stringDouble: [
      [/[^\\"]+/, 'string'],
      [/@escapes/, 'string.escape'],
      [/\\./, 'string.escape.invalid'],
      [/"/, { token: 'string.quote', bracket: '@close', next: '@pop' }],
    ],
    stringSingle: [
      [/[^\\']+/, 'string'],
      [/@escapes/, 'string.escape'],
      [/\\./, 'string.escape.invalid'],
      [/'/, { token: 'string.quote', bracket: '@close', next: '@pop' }],
    ],

    // Bloco /* */ sem suporte a aninhamento — igual ao grammar do advpl-vscode
    comment: [
      [/[^\/*]+/, 'comment'],
      [/\*\//, 'comment', '@pop'],
      [/[\/*]/, 'comment'],
    ],
  },
};

const ADVPL_LANGUAGE_CONFIGURATION = {
  comments: {
    lineComment: '//',
    blockComment: ['/*', '*/'],
  },
  brackets: [
    ['{', '}'],
    ['[', ']'],
    ['(', ')'],
  ],
  autoClosingPairs: [
    { open: '{', close: '}' },
    { open: '[', close: ']' },
    { open: '(', close: ')' },
    { open: '"', close: '"' },
    { open: '\'', close: '\'' },
  ],
  surroundingPairs: [
    { open: '{', close: '}' },
    { open: '[', close: ']' },
    { open: '(', close: ')' },
    { open: '"', close: '"' },
    { open: '\'', close: '\'' },
  ],
};

function isMonacoAvailable(monaco: any): boolean {
  return !!(
    monaco?.languages?.register &&
    monaco?.languages?.setMonarchTokensProvider &&
    monaco?.languages?.setLanguageConfiguration
  );
}

function languageAlreadyExists(monaco: any, languageId: string): boolean {
  try {
    const languages = monaco?.languages?.getLanguages?.() ?? [];
    return Array.isArray(languages) && languages.some((lang: any) => lang?.id === languageId);
  } catch {
    return false;
  }
}

export function ensureAdvplLanguageRegistered(monaco: any): void {
  if (advplLanguageRegistered) { return; }
  if (!isMonacoAvailable(monaco)) { return; }

  if (!languageAlreadyExists(monaco, ADVPL_LANGUAGE_ID)) {
    monaco.languages.register({ id: ADVPL_LANGUAGE_ID });
  }

  monaco.languages.setLanguageConfiguration(ADVPL_LANGUAGE_ID, ADVPL_LANGUAGE_CONFIGURATION);
  monaco.languages.setMonarchTokensProvider(ADVPL_LANGUAGE_ID, ADVPL_MONARCH_TOKENS);
  advplLanguageRegistered = true;
}
